
import Konsole from "./konsole/Konsole";
import moment from "moment";
import { ReturnPrice } from "./orderUtils/OrderUtils";
import { percentage_value_type, source_type_list, tax_inclusive_type } from "../constant/constant";
import { getPercentage } from "./getPercentage";



export const PICKUP_STATUS = 1;
export const DINNING_STATUS = 2;
export const DELIVERY_STATUS = 3;

export const IsNullUndefine = (val: any) => {
    if (val == undefined || val == null || val == '') {
        return true;
    }
    return false;
}


export const storeDeliveryStatusType = {
    PICKUP: 1,
    DINNING: 2,
    DELIVERY: 3
}
export const getCurrentTime = (): string => {
    const now = new Date();

    let hours = now.getHours();
    const minutes = now.getMinutes();
    // const seconds = now.getSeconds();

    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12 || 12;  // 0 becomes 12

    // Format minutes and seconds with leading zero if necessary
    const formattedMinutes = minutes.toString().padStart(2, '0');
    // const formattedSeconds = seconds.toString().padStart(2, '0');

    // Return formatted time as a string
    // return `${hours}:${formattedMinutes}:${formattedSeconds} ${period}`;

    return `${hours}:${formattedMinutes} ${period}`;

};
export const getCurrentDate = () => {
    const options: Intl.DateTimeFormatOptions = {
        weekday: "long",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    };

    return new Date()
        .toLocaleDateString("en-GB", options)
        .replace(/\//g, "-");
}

export const convertToMinutes = (timeStr: string): number => {
    const date = new Date('1970-01-01 ' + timeStr); // Dummy date to parse the time
    return date.getHours() * 60 + date.getMinutes(); // Return total minutes from midnight
};

export const convertToMinutesIphone = (timeStr: string): number => {
    const [time, period] = timeStr.split(' '); // Split into time and AM/PM
    let [hours, minutes] = time.split(':').map(Number); // Split into hours and minutes

    // Convert to 24-hour format if the period is PM and not 12 PM
    if (period === 'PM' && hours !== 12) {
        hours += 12;
    }

    // Convert 12 AM to 00:00
    if (period === 'AM' && hours === 12) {
        hours = 0;
    }

    // Return total minutes from midnight
    return hours * 60 + minutes;
};



// @@ return featured item 
export const getFeaturedItemList = (arr: any) => {
    Konsole.log('featuredData', arr)

    const filterFeaturedItem = arr.map((obj: any) => {
        return {
            ...obj,
            sub_category_data: obj?.sub_category_data?.map((sub: any) => {
                return {
                    ...sub,
                    item_data: sub?.item_data?.filter((item: any) => item?.is_featured == 1)
                }
            })?.filter((item: any) => item?.item_data.length > 0)
        }
    })?.filter((sub: any) => sub?.sub_category_data?.length > 0)

    return filterFeaturedItem;

}

// @@ return category if category have item
export const getCategoryList = (arr: any) => {
    Konsole.log('featuredData', arr)

    const filterFeaturedItem = arr.map((obj: any) => {
        return {
            ...obj,
            sub_category_data: obj?.sub_category_data?.map((sub: any) => {
                return {
                    ...sub,
                    item_data: sub?.item_data
                }
            })?.filter((item: any) => item?.item_data.length > 0)
        }
    })?.filter((sub: any) => sub?.sub_category_data?.length > 0)

    return filterFeaturedItem;

}


// Function to set a cookie   setCookie('yop-token', data.token, 7);
export function setCookie(name: any, value: any, days: any) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
}
// Function to get a cookie value by name getCookie('yop-token')
export function getCookie(name: any) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
// Function to delete a cookie
// yop-token,user-data
export function deleteCookie(name: any) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

// @@ sum of all selected options

export function getSumOfOptions(selectedOptions: any) {
    const sumOfOptions = selectedOptions?.reduce((acc: any, cu: any) => {
        acc += ReturnPrice(cu)
        return acc;
    }, 0);
    return sumOfOptions || 0;
}

export function getSumOfSelectedCategory(selectedCategory: any) {
    const sumOfCategory = selectedCategory?.reduce((acc: any, cu: any) => {
        acc += ReturnPrice(cu?.mapNewItem);
        return acc;
    }, 0);
    return sumOfCategory || 0;
}

export function getSumOfAddOn(selectedAddOn: any) {
    const sumOfAddOn = selectedAddOn?.reduce((acc: any, cu: any) => {
        acc += cu?.web_offered_price ? cu?.web_offered_price : 0 // addOnI?.offered_price//cu?.mapNewItem?.price;
        return acc;
    }, 0);
    return sumOfAddOn || 0;
}

// @@ this function for format date for display in current order and order detail
export function dateFormatOrderPlace(orderDetail: any) {
    const is_asap = orderDetail?.asap_status;
    if (is_asap == 2 && orderDetail?.selectedDate && orderDetail?.time) {
        const combinedDateTime = `${orderDetail?.selectedDate} ${orderDetail?.time}`;
        const formattedDate = moment(combinedDateTime, 'dddd DD-MM-YYYY hh:mm A').format('MMM D, YYYY hh:mm A');
        return { schedule: true, date: formattedDate };
    }
    return {
        schedule: false, date: moment(orderDetail?.updated_at).format("lll")
    }
}

// @@ logout function for use logout
export function LogoutUser() {
    // localStorage.clear();
    // sessionStorage.clear();
    deleteCookie('yop-token');
    deleteCookie('user-data');
}

export function ReturnStoreAddress(store: any) {
    // console.log('storeRe', store)
    if (store) {
        const addressS = `${store?.address}  ${store?.postal_code ? `,${store?.postal_code}` : ''} `
        return addressS;
    }
    return null;

}


export function ValidateOptionCategory(customizeData: any, stepOptionId: any, categoryId: any) {

    // @@ steps validate
    const _reqSteps = customizeData?.item_step?.filter((iStep: any) => iStep?.required == 1);
    // console.log('_reqStepsa', _reqSteps)
    if (_reqSteps?.length > 0) {
        //Konsole.log("_reqSteps", _reqSteps);
        if (stepOptionId?.length == 0) {
            return false;
        }
        const matchValidate_step = _reqSteps?.map((i: any) => stepOptionId.find((data1: any) => data1?.step_id === i?.item_step_id)).filter(Boolean);
        //Konsole.log("matchValidate", matchValidate_step);
        if (_reqSteps?.length > matchValidate_step?.length) {
            return false;
        }
    }
    //Konsole.log("_reqSteps", _reqSteps, stepOptionId);
    // @@ catrgory validatel
    const _reqCateg = customizeData?.step_sub_category_data?.filter((item: any) => item?.required == "1");
    //Konsole.log("_reqCatega", _reqCateg);
    if (_reqCateg?.length > 0) {
        //Konsole.log("_reqStepsab", categoryId, _reqCateg);
        if (categoryId?.length == 0) {
            return false;
        }
        const matchValidate_catg = _reqCateg?.map((i: any) => categoryId.find((data1: any) => data1?.side_id == i?.item_step_id)).filter(Boolean);
        //Konsole.log("matchValidate", matchValidate_catg);
        if (_reqCateg?.length > matchValidate_catg?.length) {
            return false;
        }
    }
    return true;
}


// export isTaxExclusive

export const isTaxInclusive = (type: string) => {
    return type == tax_inclusive_type
}

//export return InclusiveTaxPrice

export const ReturnItemCorrectPrice = (item_price: any, tax_rate_list: any, quantity?: any) => {
    const itemPrice = item_price;
    let subsctract_tax_price = 0
    if (tax_rate_list?.length > 0) {
        subsctract_tax_price = tax_rate_list.reduce((acc: any, curr: any) => {
            if (isTaxInclusive(curr.tax_inclusive_exclusive_type)) {
                return acc + curr.actual_tax_amount;
            }
            return acc;
        }, 0);
    }
    return itemPrice - (quantity ? subsctract_tax_price / quantity : subsctract_tax_price);
}
// utils/removeCircular.ts
export const removeCircular = (obj: any) => {
    const seen = new WeakMap();

    function serializer(value: any) {
        if (typeof value !== "object" || value === null) return value;

        if (seen.has(value)) {
            // ✅ Instead of dropping or replacing with "[Circular]",
            // clone the first copy we saw, so data is preserved
            return seen.get(value);
        }

        const clone: any = Array.isArray(value) ? [] : {};
        seen.set(value, clone);

        for (const key in value) {
            clone[key] = serializer(value[key]);
        }

        return clone;
    }

    return serializer(obj);
};


export const circulatRefrenceRemoveWithKey = (state: any) => {
    const payload = JSON.parse(JSON.stringify(state, (key, value) => {
        if (key === "textdata_for_page") {
            return undefined; // remove this property
        }
        return value;
    }));
    return payload;
}

//@@ promotions  helper
export const CheckAllStackable = (data: any) => {
    return data?.every((i: any) => i.stackable == 1)
}
export const filterStackable = (data: any) => {
    return data?.filter((i: any) => i.stackable == 1)
}

export const ReturnValidPromotions = (
    items: any[],
    subtotal: number,
    promotions: any[]
) => {
    const validPromotions = promotions.filter((promotion: any) => {
        const { source_type, source_id, minimum_cart_value } = promotion;

        // @@ cart vlaue
        if (source_type === source_type_list.cart_value) {
            return !minimum_cart_value || subtotal >= minimum_cart_value;
        }

        // @@ item
        if (source_type === source_type_list.item && subtotal >= (minimum_cart_value || 0)) {
            return items.some((item) => {
                const matchesItemId = item.item_id === source_id;
                return matchesItemId
            });
        }

        // category
        if (source_type === source_type_list.category && subtotal >= (minimum_cart_value || 0)) {
            return items.some((item) => {
                const matchesCategory = item.map_Item_Category?.some((cat: any) => cat.categoryId === source_id);
                return matchesCategory;
            });
        }

        return false;
    });

    return validPromotions;
};


export const ReturnPromotionsTotalDiscount = (subTotal: any, selectedPromotions: any) => {
    let total = selectedPromotions.reduce((acc: any, curr: any) => {
        if (curr.discount_type == percentage_value_type) {
            acc += getPercentage(subTotal, curr.discount_value)
        } else {
            acc += curr.discount_value
        }
        return acc;
    }, 0)
    return total;

}
